var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3184 3.85996L10.8625 0.404126C5.06255 4.82663 1.24422 11.6416 0.905884 19.375H5.73922C5.91041 16.3102 6.77072 13.3235 8.2561 10.6372C9.74148 7.95099 11.8137 5.63441 14.3184 3.85996ZM44.2609 19.375H49.0942C48.7317 11.6416 44.9134 4.82663 39.1376 0.404126L35.7059 3.85996C38.1999 5.64314 40.2628 7.96228 41.7432 10.6471C43.2236 13.3319 44.0839 16.3142 44.2609 19.375ZM39.5 20.5833C39.5 13.1641 35.5367 6.95329 28.625 5.30996V0.041626H21.375V5.30996C14.4392 6.95329 10.5 13.14 10.5 20.5833V32.6666L5.66672 37.5V39.9166H44.3334V37.5L39.5 32.6666V20.5833ZM25 47.1666C25.3384 47.1666 25.6525 47.1425 25.9667 47.07C27.5375 46.7316 28.8184 45.6683 29.4467 44.2183C29.6884 43.6383 29.8092 43.01 29.8092 42.3333H20.1425C20.1667 44.9916 22.3175 47.1666 25 47.1666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbell);
export default __webpack_public_path__ + "static/media/navbell.c01c0b9344dd57fae11e3b7cbd6a2349.svg";
export { ForwardRef as ReactComponent };